import { CsvFailed } from '@/assets/icons/csv-export';
import { EmptyResults } from '@/components/ats/empty-results';
import { CenterSpinner } from '@/components/ats/loadders';
import { useGetAssessmentQuery } from '@/store/query/assessment';
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Flex,
  Text,
} from '@chakra-ui/react';
import { AssessmentDetailsWrapper } from './AssessmentDetailsWrapper';
import { AssessmentInfo } from './AssessmentInfo';
import { AssessmentDetails as CodingAssessmentDetails } from '@/components/ats/job-stage-actions/actions/coding-assessment';
import { PlatformLogical, SUPPORTED_PLATFORMS } from '@/types/ext_assessment';

export const AssessmentDetails = ({
  application,
  activity = null,
  assessmentId = null,
  candidate = {},
  assessmentData,
  platform = 'internal',
}) => {
  const { data: fetchData, isLoading } = useGetAssessmentQuery(
    { assessmentId: activity?.data?.id || assessmentId },
    { skip: (!activity?.data?.id && !assessmentId) || assessmentData?.id }
  );

  const data = assessmentData?.id ? assessmentData : fetchData;

  if (isLoading) {
    return <CenterSpinner />;
  }

  if (!data?.id || data?.status === 'cancelled') {
    return (
      <EmptyResults
        icon={CsvFailed}
        wrapperProps={{ h: '100%' }}
        text={'This assessment is no longer available'}
        iconProps={{ h: '140px', w: '130px', mb: '0px' }}
        subText="NOT AVAILABLE"
      />
    );
  }

  if (SUPPORTED_PLATFORMS.includes(platform as PlatformLogical)) {
    return (
      <CodingAssessmentDetails assessmentDetails={data} platform={platform} />
    );
  }
  return (
    <Flex flexDir="column" gap="12px">
      <AssessmentInfo
        assessment={data}
        application={application}
        candidate={candidate}
      />
      <Accordion
        allowMultiple={true}
        defaultIndex={[0]}
        gap="12px"
        display="flex"
        flexDir="column"
        reduceMotion
      >
        <AccordionItem
          border="1px solid #EAEAEA"
          borderRadius="sm"
          p="0"
          data-test-id="candidate-submission-container"
        >
          <AccordionButton p="20px" _hover={{}} _focus={{}}>
            <Text
              size="md-medium"
              textAlign="left"
              flex="1"
              color="secondary-900"
            >
              Candidate submission
            </Text>
            <AccordionIcon />
          </AccordionButton>
          <AccordionPanel pb="20px" pt="0" px="20px">
            <AssessmentDetailsWrapper
              attachments={data?.submission?.attachments}
              details={data?.submission?.text}
            />
          </AccordionPanel>
        </AccordionItem>
        <AccordionItem
          border="1px solid #EAEAEA"
          borderRadius="sm"
          p="0"
          data-test-id="assessment-question-container"
        >
          <AccordionButton p="20px" _hover={{}} _focus={{}}>
            <Text
              size="md-medium"
              textAlign="left"
              flex="1"
              color="secondary-900"
            >
              Assessment question
            </Text>
            <AccordionIcon />
          </AccordionButton>
          <AccordionPanel pb="20px" pt="0" px="20px">
            <AssessmentDetailsWrapper
              attachments={data?.attachments}
              details={data?.text}
            />
          </AccordionPanel>
        </AccordionItem>
        {(data?.reviewer_instructions ||
          data?.reviewer_instructions_attachments?.length > 0) && (
          <AccordionItem border="1px solid #EAEAEA" borderRadius="sm" p="0">
            <AccordionButton p="20px" _hover={{}} _focus={{}}>
              <Text
                size="md-medium"
                textAlign="left"
                flex="1"
                color="secondary-900"
              >
                Reviewer instruction
              </Text>
              <AccordionIcon />
            </AccordionButton>
            <AccordionPanel pb="20px" pt="0" px="20px">
              <AssessmentDetailsWrapper
                attachments={data?.reviewer_instructions_attachments}
                details={data?.reviewer_instructions}
              />
            </AccordionPanel>
          </AccordionItem>
        )}
      </Accordion>
    </Flex>
  );
};
